// 右端の要素を動的に判定する関数
function updateRightItems() {
    const items = document.querySelectorAll('.un_search_item');
    const container = document.querySelector('.un_search_list');
    
    // 要素が存在しない場合は処理を終了
    if (!container || items.length === 0) {
        return;
    }
    
    const containerRect = container.getBoundingClientRect();
    
    items.forEach(item => {
        item.classList.remove('is-right');
        const itemRect = item.getBoundingClientRect();
        
        // 右端から一定の距離内にあるかチェック
        if (itemRect.right >= containerRect.right - 30) {
            item.classList.add('is-right');
        }
    });
        // リサイズ時とロード時に実行
    window.addEventListener('resize', updateRightItems);
    window.addEventListener('load', updateRightItems);
}

export default updateRightItems;